import React from 'react';

// Material UI
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    paper: {
        padding: theme.spacing(2)
    }
}))

const CardDetail = ({ title, subTitle, titleRight, divider, children, spacing = 2 }) => {
    const { classes }  = useStyles();

    return (
        <Paper className={ classes.paper }>
            <Grid container spacing={ spacing }>
                <Grid size={12}>
                    <Grid container direction='column' spacing={ 1 }>
                        <Grid>
                            <Grid container spacing={1} justifyContent='space-between' alignItems='center'>
                                <Grid>                                    
                                    <Typography variant='h5' component='h4'>
                                        { title }
                                    </Typography>
                                    {
                                        subTitle &&
                                        <Typography color="textSecondary" gutterBottom>
                                            {subTitle}
                                        </Typography>
                                    }
                                </Grid>
                                {
                                    titleRight &&
                                    <Grid>
                                        { titleRight }
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        {
                            divider &&
                            <Grid>
                                <Divider />
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Grid size={12}>
                    { children }
                </Grid>
            </Grid>
        </Paper>
    );
}

export default CardDetail;